import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../stores/useAuthStore';
import LMSHeader from '../components/LMSHeader';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { sendResetPasswordOTP, isLoading, error } = useAuthStore();
  
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await sendResetPasswordOTP(email);
    if (result.success) {
      setSuccess(true);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex flex-col">
      <LMSHeader />
      <main className="flex-1 flex items-center justify-center p-4">
      <div className="max-w-md w-full  bg-white dark:bg-neutral-800 rounded-xl shadow-sm p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-neutral-900 dark:text-white mb-2">
            Forgot Password
          </h1>
          <p className="text-neutral-600 dark:text-neutral-400">
            Enter your email address and we'll send you a code to reset your password
          </p>
        </div>

        {error && (
          <div className="mb-6 p-3 bg-danger-100 dark:bg-danger-900/30 text-danger-700 dark:text-danger-300 rounded-lg text-sm">
            {error}
          </div>
        )}

        {success ? (
          <div className="text-center">
            <div className="text-6xl mb-4">📧</div>
            <h2 className="text-xl font-semibold text-neutral-900 dark:text-white mb-2">
              Check your email
            </h2>
            <p className="text-neutral-600 dark:text-neutral-400 mb-6">
              We've sent a 6-digit code to {email}. Enter it on the next page to reset your password.
            </p>
            <button
              onClick={() => navigate('/reset-password', { state: { email } })}
              className="w-full py-3 px-4 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-800 transition-all duration-200"
            >
              Enter OTP
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 border border-neutral-300 dark:border-neutral-600 rounded-lg shadow-sm bg-white dark:bg-neutral-700 text-neutral-900 dark:text-white placeholder-neutral-500 dark:placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
                placeholder="your@email.com"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-3 px-4 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-white font-medium rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-800 transition-all duration-200"
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Sending...
                </span>
              ) : (
                'Send Reset Code'
              )}
            </button>
          </form>
        )}

        <div className="mt-8 pt-6 border-t border-neutral-200 dark:border-neutral-700 text-center">
          <button
            onClick={() => navigate('/login')}
            className="text-sm text-primary-600 dark:text-primary-400 hover:underline"
          >
            Back to login
          </button>
        </div>
      </div>
      </main>
    </div>
  );
};

export default ForgotPassword;